import { RadioGroupStyled } from "pages/Preferences/BillToSettings/BillToSettingsPage.styles.ts";
import {
	AcknowledgementPriceFormat,
	AcknowledgementPriceFormatType,
	AcknowledgmentEmailFormat,
	AcknowledgmentEmailFormatType
} from "types/declarations/enums.ts";
import { FormControlLabel, Radio } from "@mui/material";
import AcknowledgementLinePreview from "../AcknowledgementLinePreview.tsx";
import React from "react";
import {
	AcknowledgementGroupContainer,
	PreviewWrapper,
	RadioGroupContainer
} from "./BillToSettingsEmailRecipientsConfig.styles.ts";
import {
	AcknowledgementCondensedViewLabel,
	AcknowledgementExpandedViewLabel,
	BillToAcknowledgeFormatTitle,
	BillToAcknowledgeLayoutTitle,
	PriceFormatList,
	PriceFormatNet,
	PriceFormatNetWithMultiplier
} from "components/Preferences/text.ts";

type EmailFormatBinding = {
	value: AcknowledgmentEmailFormatType;
	onChange: (value: AcknowledgmentEmailFormatType) => void;
};

type PriceFormatBinding = {
	value: AcknowledgementPriceFormatType;
	onChange: (value: AcknowledgementPriceFormatType) => void;
};

interface BillToSettingsEmailRecipientsConfigProps {
	layoutField: EmailFormatBinding;
	formatField: PriceFormatBinding;
}

const BillToSettingsEmailRecipientsConfig = ({
	layoutField,
	formatField
}: BillToSettingsEmailRecipientsConfigProps) => {
	const { value: layoutValue, onChange: onLayoutChange } = layoutField;
	const { value: formatValue, onChange: onFormatChange } = formatField;

	return (
		<AcknowledgementGroupContainer>
			<span>{BillToAcknowledgeLayoutTitle}</span>
			<RadioGroupContainer>
				<RadioGroupStyled
					value={layoutValue}
					onChange={(_, value) => onLayoutChange(value as AcknowledgmentEmailFormatType)}
				>
					<FormControlLabel
						value={AcknowledgmentEmailFormat.CONDENSED}
						label={AcknowledgementCondensedViewLabel}
						control={<Radio size="small" />}
					/>
					<FormControlLabel
						value={AcknowledgmentEmailFormat.EXPANDED}
						label={AcknowledgementExpandedViewLabel}
						control={<Radio size="small" />}
					/>
				</RadioGroupStyled>
			</RadioGroupContainer>

			<span>{BillToAcknowledgeFormatTitle}</span>
			<RadioGroupContainer>
				<RadioGroupStyled
					value={formatValue}
					onChange={(_, value) => onFormatChange(value as AcknowledgementPriceFormatType)}
				>
					<FormControlLabel
						value={AcknowledgementPriceFormat.LIST}
						label={PriceFormatList}
						control={<Radio size="small" />}
					/>
					<FormControlLabel
						value={AcknowledgementPriceFormat.NET}
						label={PriceFormatNet}
						control={<Radio size="small" />}
					/>
					<FormControlLabel
						value={AcknowledgementPriceFormat.NET_MULTIPLIER}
						label={PriceFormatNetWithMultiplier}
						control={<Radio size="small" />}
					/>
				</RadioGroupStyled>
			</RadioGroupContainer>

			<PreviewWrapper>
				<AcknowledgementLinePreview
					priceType={formatValue}
					layout={layoutValue}
				/>
			</PreviewWrapper>
		</AcknowledgementGroupContainer>
	);
};

export default BillToSettingsEmailRecipientsConfig;
